import React, { useEffect, useState, KeyboardEvent } from "react";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
//import "./productstable.css";
import { Link, Navigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPencil,
  faTrash,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import Pagination from "../../common/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { EnterpriseService } from "../../service/enterprise.service";
import { Enterprise } from "../../model/enterprise.model";
import { OrdersService } from "../../service/orders.service";
import { useNavigate, useParams } from "react-router-dom";
import Button from "@mui/material/Button";
import ApprovalTwoToneIcon from '@mui/icons-material/ApprovalTwoTone';
import BlockTwoToneIcon from '@mui/icons-material/BlockTwoTone';
import TimerTwoToneIcon from '@mui/icons-material/TimerTwoTone';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { useLocation } from "react-router-dom";
import greentick from "../../greentick.png"
import redcross from "../../redcross.png"
import exclamation from "../../exclamation.png"

function OrderDetails() {
  const pageNumberLimit = 5;
  const enterpriseSvc = new EnterpriseService();
  const ordersSvc = new OrdersService();
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageLimit, setMaxPageLimit] = useState(5);
  const [minPageLimit, setMinPageLimit] = useState(0);
  //const { brandsList } = useSelector((state: any) => state.brandSlice);
  const [noOfEntries, setnoOfEntries] = useState(25);
  const dispatch = useDispatch();
  const [searchedVal, setSearchedVal] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [filteredOrderList, setFilteredOrderList] = useState<any[]>([]);
  const [selectedEnterprise, setSelectedEntprise] = useState(1);
  const [availableEnterprise, setAvailableEnterprise] = useState<Enterprise[]>([]);
  const [selectedStatus, setSelectedStatus] = useState(99);
  const [ordersData, setOrdersData] = useState<any[]>([]);
  const [filteredOrders, setFilteredOrders] = useState<any[]>([]);
  let urlParams = useParams<{ entId: string, orderId: string, selectedStatus: string }>();
  const [oinval, setOIN] = useState("");
  const navigate = useNavigate();

  
  const location = useLocation();




  //const [availableStatus, setAvailableStatus] = useState<OrderStatus[]>([]);
  const loadOrderDetailsData = () => {
    if (urlParams.entId != "" && urlParams.orderId != "" && urlParams.selectedStatus) {
      // console.log("orderdat ",urlParams.entId,'///'+urlParams.orderId)
      ordersSvc.getOrderDetails(Number(urlParams.entId), Number(urlParams.orderId)).then(res => {
        if (res.status == 100 && res.data && res.data[0]) {
          setOrdersData(res.data[0].Ddata[0].itemlist);
          // setTotalPages(res.data[0].itemList.length / noOfEntries);
          let totalPgs = Math.ceil(res.data[0].Ddata[0].itemlist.length / noOfEntries);
          setTotalPages(totalPgs);
        } else {
          setOrdersData([]);
          toast.error("No Data Available!!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          });
          setTimeout(() => {
            navigateToList(true)
          }, 2100);
        }
      })
    }
  }

  const navigateToList = (replace: boolean) => {

    console.log("pathh ::  : " + location.pathname);
    let sourcee = "";
    if (location.pathname.includes("newnotifications")) {
      sourcee = "../newnotifications"
    } else {
      sourcee = "../orders"
    }

    if (replace) {
      navigate(sourcee, { replace: true })
    } else {
      navigate(sourcee)
    }
  }


  useEffect(() => {

    if (ordersData) {
      const start = (currentPage - 1) * noOfEntries;
      let ordersList = ordersData.slice(start, start + noOfEntries);
      setFilteredOrders([...ordersList]);
    }
  }, [currentPage, ordersData])


  //const location = useLocation();

  //console.log("%%%%%%%%%%%%%%%%%%OrderId : "+location.state.orderId);

  const pdfDownload = (entid: number, orderid:number) => {
    ordersSvc.downloadPdf(entid, orderid).then(data => {
      const res = data.data;
      
      const blob = new Blob([data], { type: 'application/pdf' });
      const fileUrl = URL.createObjectURL(blob);
      /*const w = window.open(fileUrl, '_blank');
      w && w.focus();*/
    var file_name = entid + '_' + orderid +'.pdf';
    console.log("``````````````` : "+entid+":"+ orderid + ":" + file_name)
      let alink = document.createElement('a');
                alink.href = fileUrl;
                alink.download = file_name;
                alink.click();

  })
}


  let loaddatacalled = false;
  useEffect(() => {

    if (!loaddatacalled) {


      loaddatacalled = true;
      loadOrderDetailsData();
    }
  }, []);

  const onPageChange = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const onPrevClick = (count: number) => {
    if ((currentPage - 1) % pageNumberLimit === 0) {
      setMaxPageLimit(maxPageLimit - pageNumberLimit);
      setMinPageLimit(minPageLimit - pageNumberLimit);
    }
    setCurrentPage((prev) => prev - 1);
  };

  const onNextClick = (page: number) => {
    if (currentPage + 1 > maxPageLimit) {
      setMaxPageLimit(maxPageLimit + pageNumberLimit);
      setMinPageLimit(minPageLimit + pageNumberLimit);
    }
    setCurrentPage(page);
  };

  const onAccept = () => {
    if (oinval.length < 4) {
      toast.error("Please enter valid(Min. 4 digits) Order Number!!!", {
        position: toast.POSITION.BOTTOM_CENTER,
        autoClose: 2000,
        hideProgressBar: true,
      });
    } else {
      ordersSvc.setOrderStatus(Number(urlParams.orderId), 1, oinval).then(res => {
        if (res.status == '100') {
          pdfDownload(Number(urlParams.entId) ,Number(urlParams.orderId))
          setFilteredOrders([]);
          toast.success("Updated Successfully !!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          });
          setTimeout(() => {
            navigateToList(true)
          }, 2100);

        } else {
          setFilteredOrders([]);
          toast.error("Update Failed !!!", {
            position: toast.POSITION.BOTTOM_CENTER,
            autoClose: 2000,
            hideProgressBar: true,
          });
          setTimeout(() => {
            navigateToList(true)
          }, 2100);
        }
      })
    }
  };

  const onReject = () => {
    ordersSvc.setOrderStatus(Number(urlParams.orderId), 0, oinval).then(res => {
      if (res.status == '100') {
        setFilteredOrders([]);
        toast.success("Updated Successfully !!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigateToList(true)
        }, 2100);

      } else {
        setFilteredOrders([]);
        toast.error("Update Failed !!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigateToList(true)
        }, 2100);
      }
    })
  };
  const onPending = () => {
    ordersSvc.setOrderStatus(Number(urlParams.orderId), -1, oinval).then(res => {
      if (res.status == '100') {
        setFilteredOrders([]);
        toast.success("Updated Successfully !!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigateToList(true)
        }, 2100);

      } else {
        setFilteredOrders([]);
        toast.error("Update Failed !!!", {
          position: toast.POSITION.BOTTOM_CENTER,
          autoClose: 2000,
          hideProgressBar: true,
        });
        setTimeout(() => {
          navigateToList(true)
        }, 2100);
      }
    })
  };
  const onCancel = () => {
    navigateToList(false)
  };
  const handleOINChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setOIN(event.target.value);
  };

  

  return (
    <div className="App border">
      <div className="border-bottom m-0 pb-1 pt-1 row ">
        <div className="row col-md-2">
          <input type="text" className="form-inline" name='OIN' placeholder="Enter ERP Order No."
            id="OINData" onChange={handleOINChange} value={oinval} defaultValue={""} />
        </div>
        <div className="form-inline ml-4">
          {urlParams.selectedStatus != "1" && (
            <Button size="small" style={{ color: "green" }} className="mr-4 btn btn-sm" onClick={onAccept} variant="text" startIcon={<ApprovalTwoToneIcon fontSize="small" />}> Approve</Button>


          )}
          {urlParams.selectedStatus != "0" && (
            <Button size="small" style={{ color: "red" }} className="mr-4" onClick={onReject} variant="text" startIcon={<BlockTwoToneIcon fontSize="small" />}> Reject</Button>

          )}
          <Button size="small" style={{ color: "blue" }} className="mr-4" onClick={onPending} variant="text" startIcon={<BlockTwoToneIcon fontSize="small" />}> Pending</Button>

          <Button size="small" style={{ color: "#424242" }} className="mr-4" onClick={onCancel} variant="text" startIcon={<ClearOutlinedIcon fontSize="small" />}> Exit</Button>

        </div>
        <ToastContainer />
      </div>

      <table className="table table-striped mb-0 table-bordered">
        <thead>
          <tr>
            <th scope="col">Image</th>
            <th scope="col">Product Code</th>
            <th scope="col">Model</th>
            <th scope="col">Size</th>
            <th scope="col">Finish</th>
            <th scope="col">Product Name</th>
            <th scope="col">Quantity</th>
            <th scope="col">MRP</th>
            <th scope="col">Stock status</th>
          </tr>
        </thead>
        <tbody>
          {filteredOrders &&
            filteredOrders
              .map((getordersList: any, index: number) => {
                return (
                  <tr key={index}>
                    <td> <img
                      style={{ width: "50px", height: "30px" }}
                      src={getordersList.imgurl}
                    ></img> </td>
                    <td>{getordersList.prodCode}</td>
                    <td>{getordersList.modelNum}</td>
                    <td>{getordersList.size}</td>
                    <td>{getordersList.finish}</td>
                    <td>{getordersList.itemdesc}</td>
                    <td>{getordersList.qty}</td>
                    <td>{getordersList.mrp}</td>
                    { getordersList.stockstatus == 0 && (
                      <td>{<img src={redcross} style={{ width:'20px' }}></img>} </td>
                      ) || getordersList.stockstatus == 1 && (
                      <td>{<img src={greentick} style={{ width:'20px' }}></img>} </td>
                      ) || getordersList.stockstatus == 2 && (
                        <td>{<img src={exclamation} style={{ width:'20px' }}></img>} </td>
                        )
                    }

                    { /* <Link
                        to={`${getordersList.Id}`}
                        className="pr-4 text-dark"
                      >
                        <FontAwesomeIcon icon={faPencil} />
                        <span className="ml-1 mb-0">Edit</span>
                      </Link> */}
                    {/* <Link
                        to={`1234`}
                        className="pr-4 text-dark"
                        data-toggle="modal"
                        data-target="#myModal"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                        <span className="ml-1 mb-0">Delete</span>
                      </Link> */}

                  </tr>
                );
              })}
        </tbody>
      </table>

    </div>
  );
}

export default OrderDetails;
